import PropTypes from 'prop-types';
import React from 'react';

import { reportError } from './helpers';

class InternalErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: undefined };
  }

  componentDidCatch(error, info) {
    reportError(error, { componentStack: info?.componentStack });
    this.setState({ error });
  }

  render() {
    const { children } = this.props;
    const { error } = this.state;
    if (error) throw error;
    return children || null;
  }
}

InternalErrorBoundary.displayName = 'core:components:ErrorBoundary';

InternalErrorBoundary.propTypes = {
  children: PropTypes.node,
};

const ErrorBoundary = (props) => React.createElement(InternalErrorBoundary, props);

ErrorBoundary.displayName = InternalErrorBoundary.displayName;

ErrorBoundary.propTypes = InternalErrorBoundary.propTypes;

export { ErrorBoundary };
